import { takeEvery, all } from 'redux-saga/effects';
import { GET_OVERRIDES_LIST, GET_OVERRIDE_DETAILS, GET_OVERRIDE_REASONS, EDIT_PRICE_OVERRIDE } from '../actions';
import { getOverridesListData } from './overridesListSaga';
import { getOverrideDetailsData } from './overrideDetailsSaga';
import { getOverrideReasonsData } from './overrideReasonsSaga';
import { editPriceOverrideData } from './editPriceOverrideSaga';
import { REASSIGN_OVERRIDE, GET_REASSIGN_OVERRIDE_USERS } from '../actions';
import reassignOverrideSaga from './reassignOverrideSaga';
import { getReassignOverrideUsersData } from './reassignOverrideUsersSaga';
import { DENY_OVERRIDE } from '../actions';
import denyOverrideSaga from './denyOverrideSaga';
import { APPROVE_OVERRIDE } from '../actions';
import approveOverrideSaga from './approvalOverrideSaga';
import { CANCEL_OVERRIDE } from '../actions';
import cancelOverrideSaga from './cancelOverrideSaga';

function* watchGetOverridesList() {
    yield takeEvery(GET_OVERRIDES_LIST, getOverridesListData);
}

function* watchGetOverrideDetails() {
    yield takeEvery(GET_OVERRIDE_DETAILS, getOverrideDetailsData);
}

function* watchGetOverrideReasons() {
    yield takeEvery(GET_OVERRIDE_REASONS, getOverrideReasonsData);
}

function* watchEditPriceOverride() {
    yield takeEvery(EDIT_PRICE_OVERRIDE, editPriceOverrideData);
}

function* watchReassignOverride() {
    yield takeEvery(REASSIGN_OVERRIDE, reassignOverrideSaga);
}

function* watchGetReassignOverrideUsers() {
    yield takeEvery(GET_REASSIGN_OVERRIDE_USERS, getReassignOverrideUsersData);
}



function* watchDenyOverride() {
    yield takeEvery(DENY_OVERRIDE, denyOverrideSaga);
}

function* watchApproveOverride() {
    yield takeEvery(APPROVE_OVERRIDE, approveOverrideSaga);
}

function* watchCancelOverride() {
    yield takeEvery(CANCEL_OVERRIDE, cancelOverrideSaga);
}

export default function* overridesSaga() {
    yield all([watchGetOverridesList(), watchGetOverrideDetails(), watchGetOverrideReasons(), watchEditPriceOverride(), watchReassignOverride(), watchGetReassignOverrideUsers(), watchDenyOverride(), watchApproveOverride(), watchCancelOverride()]);
}

